export enum PaymentMethod {
  CREDIT_CARD = 'credit-card'
}

export enum EPaymentStatus {
  FAILED = 'failed',
  SUCCESS = 'success'
}

export enum EPaymentTerminalStatus {
  PENDING = 'pending',
  SUCCESS = 'completed',
  FAILED = 'failed'
}
